import React from "react";
import App, { Container } from "next/app";
import Head from "next/head";
import Router from "next/router";
import NProgress from "nprogress";
import toastifyStyles from "react-toastify/dist/ReactToastify.min.css";
// import { MixpanelProvider, MixpanelConsumer } from "react-mixpanel";
import styles from "./_app.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Wrapper from "../components/Wrapper";
import * as gtag from "../utils/gtag";
// import mixpanel from "mixpanel-browser";
import ReactInputStyle from "react-phone-input-2/lib/style.css";
import AdminLayoutProvider from "../contexts/AdminLayout";
import AOS from "aos";
import aosStyles from "aos/dist/aos.css";
import CookiePopup from "../components/CookiePopup";
import { pageRoutesWithoutLayout } from "../utils/constants"
import ErrorBoundary from '../components/ErrorBoundary'


// import "bootstrap/dist/css/bootstrap.css";
// import "jquery/dist/jquery";
// import "popper.js";
// import "bootstrap/dist/js/bootstrap";

// NProgress.configure({ showSpinner: false });

// mixpanel.init("70039510aadde550396be05f4e338247");

const handleRouteChange = (url) => {
  NProgress.start();
};

Router.events.on("routeChangeStart", handleRouteChange);
Router.events.on("routeChangeComplete", (url) => {
  NProgress.done();
  // gtag.pageview(url);
});
Router.events.on("routeChangeError", () => NProgress.done());

class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {
      hasFooter: pageRoutesWithoutLayout.includes(ctx.pathname) ? false : true,
      hasHeader: pageRoutesWithoutLayout.includes(ctx.pathname) ? false : true,
      authenticated: false,
      authenticationType: null,
    };

    if (Component.getInitialProps) {
      let thisPageProps = await Component.getInitialProps(ctx);
      pageProps = { ...pageProps, ...thisPageProps };
    }


    return { pageProps };
  }

  componentDidMount() {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }

  render() {
    const {
      Component,
      pageProps: { hasHeader, hasFooter, noPadding, authenticated },
    } = this.props;

    return (
      <Container>
        <Head>
          <title>1Gov</title>
          <link
            rel="shortcut icon"
            href="/static/favicon.png"
            type="image/x-icon"
          />
        </Head>
        <AdminLayoutProvider>
          <Wrapper hasWrapper={authenticated}>
            {hasHeader && <Navbar authenticated={authenticated} />}
            <main
              className={`main-component ${hasHeader && !authenticated && !noPadding
                ? "with-padding"
                : ""
                }`}
            >
              <ErrorBoundary>
                  <Component {...this.props.pageProps} />
              </ErrorBoundary>
              <CookiePopup />
            </main>
            {hasFooter && <Footer authenticated={authenticated} />}
          </Wrapper>
        </AdminLayoutProvider>


        {/* <MixpanelProvider mixpanel={mixpanel}>
          <MixpanelConsumer>
            {(mixpanel) => (
              <AdminLayoutProvider>
                <Wrapper hasWrapper={authenticated}>
                  {hasHeader && <Navbar authenticated={authenticated} />}
                  <main
                    className={`main-component ${
                      hasHeader && !authenticated && !noPadding
                        ? "with-padding"
                        : ""
                    }`}
                  >
                    <Component {...this.props.pageProps} />
                    <CookiePopup />
                  </main>
                  {hasFooter && <Footer authenticated={authenticated} />}
                </Wrapper>
              </AdminLayoutProvider>
            )}
          </MixpanelConsumer>
        </MixpanelProvider> */}
        <style jsx global>
          {styles}
        </style>
        <style jsx global>
          {toastifyStyles}
        </style>
        <style jsx global>
          {ReactInputStyle}
        </style>
        <style jsx global>
          {aosStyles}
        </style>
        {/* <div id='zsiqwidget'></div> */}
      </Container>
    );
  }
}

export default MyApp;
